export default "__VITE_ASSET__dc78fcd2__"